import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CookieConsentContext } from "@/contexts/CookieConsentContext";
import { useTranslation } from "react-i18next";
import i18next, { changeLanguageSafe } from "@/i18n";

const Footer = () => {
  const cookie = useContext(CookieConsentContext);
  const { t } = useTranslation();
  const [lang, setLang] = useState(i18next.language || "de");
  useEffect(() => {
    const handler = (l) => setLang(l);
    i18next.on('languageChanged', handler);
    return () => i18next.off('languageChanged', handler);
  }, []);
  const changeLanguage = async (l) => {
    setLang(l);
    await changeLanguageSafe(l);
    try { localStorage.setItem('i18nextLng', l); } catch {}
    // Also persist to a cookie so language survives across tabs/origins (non-HttpOnly)
    try {
      document.cookie = `i18next=${encodeURIComponent(l)}; path=/; max-age=${60 * 60 * 24 * 365}`;
      // Update <html lang="..."> for accessibility and SEO
      if (document && document.documentElement) {
        document.documentElement.setAttribute('lang', l);
      }
    } catch {}
  };
  const version = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_APP_VERSION) ? String(import.meta.env.VITE_APP_VERSION) : null;
  return (
    <footer className="border-t mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-muted-foreground">
        <div className="flex flex-col sm:flex-row gap-3 items-center justify-between">
          <div className="flex items-center gap-3">
            <span>© {new Date().getFullYear()} Scanmirein</span>
            {version && <span className="text-muted-foreground">Version {version}</span>}
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <Link to="/status" className="hover:text-foreground">{t('status.title') || 'Status'}</Link>
            <Link to="/impressum" className="hover:text-foreground">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-foreground">Datenschutz</Link>
            <button
              type="button"
              onClick={() => cookie.openPreferences(true)}
              className="hover:text-foreground"
            >Cookies</button>
            <div className="flex items-center gap-1">
              <label htmlFor="footer-lang" className="text-muted-foreground hidden sm:inline">{t('language.label') || 'Sprache'}</label>
              <select
                id="footer-lang"
                value={lang}
                onChange={(e) => changeLanguage(e.target.value)}
                className="border rounded px-2 py-1 text-xs bg-background hover:bg-muted"
              >
                <option value="de">{t('language.de') || 'Deutsch'}</option>
                <option value="en">{t('language.en') || 'English'}</option>
                <option value="es">{t('language.es') || 'Español'}</option>
              </select>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
